var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState, useCallback, } from 'react';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { RecordButton } from '@backrs_ui/common-ui/src/atoms/RecordButton';
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { useAudioRecorder, } from '@backrs_ui/common-ui/src/hooks/useAudioRecorder';
import { AttachedFileChip } from '@backrs_ui/common-ui/src/molecules/Lubav/AttachedFileChip';
import { Box, Button, IconButton, useMediaQuery } from '@mui/material';
import TextareaAutosize from 'react-textarea-autosize';
var INPUT_BOX_STRINGS = appStrings.modules.lubav.inputBox;
var RECORDING_ERRORS = appStrings.modules.audioRecording.errors;
export var NUGGET_DRAG_TYPE = 'application/x-backrs-nugget';
var CHAT_ATTACHMENT_MIME_TYPES = new Set([
    'image/jpeg',
    'image/png',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/plain',
]);
var MAX_FILE_SIZE = 10 * 1024 * 1024;
var MAX_RECORDING_MS = 2 * 60 * 1000;
var partitionValidFiles = function (files) {
    var valid = [];
    var rejected = 0;
    for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
        var file = files_1[_i];
        if (CHAT_ATTACHMENT_MIME_TYPES.has(file.type) && file.size <= MAX_FILE_SIZE) {
            valid.push(file);
        }
        else {
            rejected += 1;
        }
    }
    return { valid: valid, rejected: rejected };
};
var withPasteFilename = function (file) {
    if (file.name)
        return file;
    var extension = file.type.split('/')[1];
    return new File([file], extension ? "pasted-file.".concat(extension) : 'pasted-file', {
        type: file.type,
    });
};
var noTranscription = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2, ''];
}); }); };
export var InputBox = function (_a) {
    var _b = _a.value, value = _b === void 0 ? '' : _b, onChange = _a.onChange, onSend = _a.onSend, onStop = _a.onStop, _c = _a.isNumeric, isNumeric = _c === void 0 ? false : _c, _d = _a.placeholder, placeholder = _d === void 0 ? undefined : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.sendButtonDisabled, sendButtonDisabled = _f === void 0 ? false : _f, _g = _a.isStreaming, isStreaming = _g === void 0 ? false : _g, _h = _a.readOnly, readOnly = _h === void 0 ? false : _h, _j = _a.attachedNuggets, attachedNuggets = _j === void 0 ? [] : _j, onNuggetDrop = _a.onNuggetDrop, onNuggetRemove = _a.onNuggetRemove, renderAttachedNugget = _a.renderAttachedNugget, _k = _a.attachedFiles, attachedFiles = _k === void 0 ? [] : _k, onFileSelect = _a.onFileSelect, onFileRemove = _a.onFileRemove, onFileValidationError = _a.onFileValidationError, onTranscribe = _a.onTranscribe, onRecordingError = _a.onRecordingError;
    var textareaRef = useRef(null);
    var fileInputRef = useRef(null);
    var isMobile = useMediaQuery('(max-width: 900px)');
    var _l = useState(false), isDragOver = _l[0], setIsDragOver = _l[1];
    var valueRef = useRef(value);
    valueRef.current = value;
    var handleTranscript = useCallback(function (text) {
        var existing = valueRef.current.trimEnd();
        onChange === null || onChange === void 0 ? void 0 : onChange(existing ? "".concat(existing, " ").concat(text) : text);
    }, [onChange]);
    var handleRecordingError = useCallback(function (reason) {
        onRecordingError === null || onRecordingError === void 0 ? void 0 : onRecordingError(RECORDING_ERRORS[reason]);
    }, [onRecordingError]);
    var _m = useAudioRecorder({
        transcribe: onTranscribe !== null && onTranscribe !== void 0 ? onTranscribe : noTranscription,
        onTranscript: handleTranscript,
        onError: handleRecordingError,
        maxDurationMs: MAX_RECORDING_MS,
    }), recordingStatus = _m.status, startRecording = _m.startRecording, stopRecording = _m.stopRecording;
    var isRecording = recordingStatus === 'recording';
    var isTranscribing = recordingStatus === 'transcribing';
    var handleInputChange = function (newValue) {
        if (isNumeric && isNaN(Number(newValue)))
            return;
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    };
    var hasUploadingFiles = attachedFiles.some(function (f) { return f.uploadStatus === 'uploading'; });
    var isSendBlocked = disabled || sendButtonDisabled || hasUploadingFiles || isRecording || isTranscribing;
    var handleSendMessage = function () {
        if (!value.trim() || isSendBlocked)
            return;
        onSend === null || onSend === void 0 ? void 0 : onSend();
    };
    var handleStopStreaming = function () {
        onStop === null || onStop === void 0 ? void 0 : onStop();
    };
    var handleKeyPress = function (e) {
        if (e.key === 'Enter' && !e.shiftKey && !isSendBlocked) {
            e.preventDefault();
            handleSendMessage();
        }
    };
    var handleFileInputChange = function (e) {
        var _a;
        var files = Array.from((_a = e.target.files) !== null && _a !== void 0 ? _a : []);
        var _b = partitionValidFiles(files), valid = _b.valid, rejected = _b.rejected;
        if (valid.length > 0) {
            onFileSelect === null || onFileSelect === void 0 ? void 0 : onFileSelect(valid);
        }
        if (rejected > 0) {
            onFileValidationError === null || onFileValidationError === void 0 ? void 0 : onFileValidationError(INPUT_BOX_STRINGS.fileValidationError);
        }
        e.target.value = '';
    };
    var handleDragOver = useCallback(function (event) {
        var hasNugget = event.dataTransfer.types.includes(NUGGET_DRAG_TYPE);
        var hasFiles = event.dataTransfer.types.includes('Files');
        if ((hasNugget && onNuggetDrop) || (hasFiles && onFileSelect)) {
            event.preventDefault();
            event.dataTransfer.dropEffect = 'copy';
            setIsDragOver(true);
        }
    }, [onNuggetDrop, onFileSelect]);
    var handleDragLeave = useCallback(function () {
        setIsDragOver(false);
    }, []);
    var handleDrop = useCallback(function (event) {
        event.preventDefault();
        setIsDragOver(false);
        var data = event.dataTransfer.getData(NUGGET_DRAG_TYPE);
        if (data && onNuggetDrop) {
            try {
                var nugget = JSON.parse(data);
                onNuggetDrop(nugget);
            }
            catch (_a) {
            }
            return;
        }
        if (event.dataTransfer.files.length > 0 && onFileSelect) {
            var _b = partitionValidFiles(Array.from(event.dataTransfer.files)), valid = _b.valid, rejected = _b.rejected;
            if (valid.length > 0) {
                onFileSelect(valid);
            }
            if (rejected > 0) {
                onFileValidationError === null || onFileValidationError === void 0 ? void 0 : onFileValidationError(INPUT_BOX_STRINGS.fileValidationError);
            }
        }
    }, [onNuggetDrop, onFileSelect, onFileValidationError]);
    var handlePaste = useCallback(function (event) {
        var files = Array.from(event.clipboardData.files);
        if (files.length === 0 || !onFileSelect)
            return;
        event.preventDefault();
        var _a = partitionValidFiles(files.map(withPasteFilename)), valid = _a.valid, rejected = _a.rejected;
        if (valid.length > 0) {
            onFileSelect(valid);
        }
        if (rejected > 0) {
            onFileValidationError === null || onFileValidationError === void 0 ? void 0 : onFileValidationError(INPUT_BOX_STRINGS.fileValidationError);
        }
    }, [onFileSelect, onFileValidationError]);
    useEffect(function () {
        var _a;
        if (!disabled && !isMobile) {
            (_a = textareaRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [disabled, isMobile]);
    var hasAttachedNuggets = attachedNuggets.length > 0;
    var hasAttachedFiles = attachedFiles.length > 0;
    var showInlineRecordButton = Boolean(onTranscribe) && isMobile && !readOnly && (!value || isRecording || isTranscribing);
    var renderRecordButton = function (id) { return (_jsx(RecordButton, { id: id, status: recordingStatus, label: isRecording ? INPUT_BOX_STRINGS.stopRecording : INPUT_BOX_STRINGS.recordMessage, onStart: startRecording, onStop: stopRecording, disabled: disabled, sx: recordButtonSx })); };
    return (_jsxs(Box, { sx: containerStyle(isMobile, readOnly), children: [onFileSelect && (_jsx("input", { ref: fileInputRef, type: "file", accept: ".jpg,.jpeg,.png,.pdf,.docx,.txt", multiple: true, onChange: handleFileInputChange, style: { display: 'none' } })), _jsxs(Box, { sx: boxStyle(isDragOver, isMobile), onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop, children: [hasAttachedNuggets && renderAttachedNugget && (_jsx(Box, { sx: attachedNuggetsContainerSx, children: attachedNuggets.map(function (nugget) { return (_jsx(Box, { children: renderAttachedNugget(nugget, function () { return onNuggetRemove === null || onNuggetRemove === void 0 ? void 0 : onNuggetRemove(nugget.id); }) }, "".concat(nugget.type, "-").concat(nugget.id))); }) })), hasAttachedFiles && (_jsx(Box, { sx: attachedNuggetsContainerSx, children: attachedFiles.map(function (file) { return (_jsx(AttachedFileChip, { filename: file.filename, status: file.uploadStatus, onRemove: onFileRemove && file.uploadStatus !== 'uploading'
                                ? function () { return onFileRemove(file.s3_key); }
                                : undefined }, file.s3_key || file.filename)); }) })), _jsxs(Box, { sx: textareaRowSx, children: [_jsxs(Box, { sx: textareaWrapperSx, children: [_jsx(TextareaAutosize, { id: "lubav-chat-textarea", ref: textareaRef, value: value, onChange: function (e) { return handleInputChange(e.target.value); }, onKeyPress: handleKeyPress, onPaste: handlePaste, "aria-placeholder": !disabled ? placeholder || INPUT_BOX_STRINGS.typeAMessage : undefined, style: messageInputTextarea(isMobile), disabled: disabled || readOnly, minRows: 1, maxRows: Math.floor((window.innerHeight * 0.2) / 24) }), !value && !disabled && (_jsx(Box, { sx: placeholderOverlaySx(isMobile), children: placeholder || INPUT_BOX_STRINGS.typeAMessage }))] }), showInlineRecordButton && renderRecordButton('lubav-input-record-btn-mobile')] }), _jsxs(Box, { sx: bottomRowSx, children: [onFileSelect && !readOnly && !isMobile && (_jsx(IconButton, { id: "lubav-input-attach-file-btn", size: "small", onClick: function () { var _a; return (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, disabled: disabled, sx: attachButtonSx, children: _jsx(AppIcon, { iconName: "Paperclip", diameter: "20px", color: "Colors/Foreground/fg-quaternary" }) })), onTranscribe && !readOnly && !isMobile && renderRecordButton('lubav-input-record-btn'), _jsx(Box, { sx: { flex: 1 } }), !readOnly &&
                                !isMobile &&
                                (isStreaming ? (_jsxs(Button, { id: "lubav-input-stop-button-desktop", onClick: handleStopStreaming, hierarchy: "Secondary gray", size: "md", sx: stopButtonSx, children: [_jsx(AppIcon, { iconName: "Square", diameter: "12px", color: "Colors/Foreground/fg-quaternary", fill: "Colors/Foreground/fg-quaternary" }), INPUT_BOX_STRINGS.stop] })) : (_jsx(Button, { id: "lubav-input-send-button-desktop", onClick: handleSendMessage, disabled: isSendBlocked, hierarchy: "Primary", size: "md", children: INPUT_BOX_STRINGS.send })))] })] }), !readOnly && isMobile && (_jsxs(Box, { sx: mobileButtonsSx, children: [onFileSelect && (_jsx(IconButton, { id: "lubav-input-attach-file-btn-mobile", size: "small", onClick: function () { var _a; return (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, disabled: disabled, sx: attachButtonSx, children: _jsx(AppIcon, { iconName: "Paperclip", diameter: "20px", color: "Colors/Foreground/fg-quaternary" }) })), isStreaming ? (_jsx(Button, { id: "lubav-input-stop-button-mobile", onClick: handleStopStreaming, hierarchy: "Secondary gray", size: "md", sx: iconButtonStyle, children: _jsx(AppIcon, { iconName: "Square", diameter: "20px", color: "Colors/Foreground/fg-quaternary", fill: "Colors/Foreground/fg-quaternary" }) })) : (_jsx(Button, { id: "lubav-input-send-button-mobile", onClick: handleSendMessage, disabled: isSendBlocked, hierarchy: "Primary", size: "md", sx: iconButtonStyle, children: _jsx(AppIcon, { iconName: "Send01", diameter: "20px", color: "Colors/Base/White" }) }))] }))] }));
};
var containerStyle = function (isMobile, readOnly) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            width: '100%',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'row',
            alignItems: isMobile ? 'center' : 'flex-end',
            gap: backrs.spacing['spacing-sm'],
            borderRadius: backrs.radius['radius-md'],
            pb: isMobile && !readOnly ? backrs.spacing['spacing-lg'] : undefined,
            pointerEvents: readOnly ? 'none' : undefined,
        });
    };
};
var boxStyle = function (isDragOver, isMobile) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            border: "1px solid ".concat(isDragOver ? backrs.colors['Brand/600'] : isMobile ? backrs.colors['Colors/Border/border-secondary'] : backrs.colors['Beige/950']),
            borderRadius: isMobile ? backrs.radius['radius-xl'] : backrs.radius['radius-md'],
            flex: 1,
            pl: isMobile ? backrs.spacing['spacing-lg'] : backrs.spacing['spacing-md'],
            pr: isMobile ? backrs.spacing['spacing-lg'] : backrs.spacing['spacing-md'],
            minHeight: isMobile ? '56px' : undefined,
            backgroundColor: isDragOver ? backrs.colors['Brand/50'] : 'transparent',
            transition: 'border-color 0.2s, background-color 0.2s',
        });
    };
};
var textareaRowSx = {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
};
var textareaWrapperSx = {
    position: 'relative',
    flex: 1,
    minWidth: 0,
};
var attachedNuggetsContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexWrap: 'wrap',
        gap: backrs.spacing['spacing-sm'],
        pt: backrs.spacing['spacing-md'],
        width: '100%',
    });
};
var inputTextSx = function (isMobile) { return ({
    fontSize: '1rem',
    lineHeight: '1.5rem',
    padding: isMobile ? '14px 4px' : '12px 8px',
}); };
var messageInputTextarea = function (isMobile) { return (__assign(__assign({}, inputTextSx(isMobile)), { width: '100%', resize: 'none', border: 'none', outline: 'none', fontFamily: 'inherit', overflowY: 'auto', letterSpacing: '0', fontWeight: '400', display: 'flex', alignItems: 'center', backgroundColor: 'transparent' })); };
var placeholderOverlaySx = function (isMobile) {
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign(__assign({}, inputTextSx(isMobile)), { position: 'absolute', inset: 0, color: backrs.colors['Colors/Text/text-placeholder'], pointerEvents: 'none', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }));
    };
};
var iconButtonStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        padding: backrs.spacing['spacing-md'],
    });
};
var stopButtonSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        alignItems: 'center',
        gap: backrs.spacing['spacing-xs'],
    });
};
var mobileButtonsSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: backrs.spacing['spacing-xs'],
    });
};
var bottomRowSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        pb: backrs.spacing['spacing-sm'],
    });
};
var attachButtonSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        padding: backrs.spacing['spacing-xs'],
        flexShrink: 0,
    });
};
var recordButtonSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        padding: backrs.spacing['spacing-xs'],
        flexShrink: 0,
        color: backrs.colors['Colors/Foreground/fg-quaternary'],
    });
};
